export const SIDEBAR_DIALOG_EVENT_TYPE = 'placer_sidebar_dialog';

export type SidebarState = 'open' | 'close';
